import { useQuery } from '@tanstack/react-query'
import { api } from '@lipaflow/shared'


interface Liveness {
  status: string
  version: string
  environment: string
}

/** Version and environment as the running API reports them (not the build mode). */
export function usePlatformInfo() {
  const root = String(api.defaults.baseURL ?? '').replace(/\/api\/v1\/?$/, '')
  return useQuery({
    queryKey: ['platform', 'liveness'],
    queryFn: async () => (await api.get<Liveness>('/health', { baseURL: root })).data,
  })
}
